import { render } from "./Diretoria.vue?vue&type=template&id=d496502c&scoped=true"
import script from "./Diretoria.vue?vue&type=script&lang=js"
export * from "./Diretoria.vue?vue&type=script&lang=js"

import "./Diretoria.vue?vue&type=style&index=0&id=d496502c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d496502c"]])

export default __exports__